import { render, staticRenderFns } from "./edit_modal.vue.html?vue&type=template&id=5bc0fcfa"
import script from "./edit_modal.controller?vue&type=script&lang=js&external"
export * from "./edit_modal.controller?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports